import { createRouter as createVueRouter, createWebHistory, Router } from 'vue-router'
import { getRoutes } from './routes'
import type { App } from 'vue'

let router: Router | null = null

export function initRouter(app: App): Router {
  router = createVueRouter({
    routes: getRoutes(app),
    history: createWebHistory(process.env.BASE_URL)
  })
  return router
}

export function getRouter(): Router {
  if (!router) throw new Error('Router not initialized yet')
  return router
}

export { router }
export default router
